import type { ApplyRobotEcnBody, ListRobotEcnsResponse, RobotEcnDto } from '@bhops/shared';
import { apiClient } from './client';

// S2 Phase 2.4 — 로봇 ↔ ECN 정방향 태깅 typed client.
// robot-qrs.ts / ecns.ts 와 동일한 apiClient 래핑 패턴.
// robots/:robotId/ecns 하위 — list(정방향) / apply(수동 태깅) / remove(해제).

export const robotEcnsApi = {
  async list(robotId: string): Promise<ListRobotEcnsResponse> {
    const { data } = await apiClient.get<ListRobotEcnsResponse>(
      `/robots/${encodeURIComponent(robotId)}/ecns`,
    );
    return data;
  },

  async apply(robotId: string, body: ApplyRobotEcnBody): Promise<RobotEcnDto> {
    const { data } = await apiClient.post<RobotEcnDto>(
      `/robots/${encodeURIComponent(robotId)}/ecns`,
      body,
    );
    return data;
  },

  async remove(robotId: string, robotEcnId: string): Promise<void> {
    await apiClient.delete(
      `/robots/${encodeURIComponent(robotId)}/ecns/${encodeURIComponent(robotEcnId)}`,
    );
  },
};
